<template>
  <div class="ml-4" v-if="hasRoles">
    <!-- <a @click="$router.push('/approval')"> <a-icon type="home" /> Quy trình </a>
    <span class="ml-2"> | </span> -->
    <a class="ml-2" @click="$router.push('/reports')">
      <a-icon type="pie-chart" /> Báo cáo
    </a>
  </div>
</template>
<script>
import Query from "./query";
export default {
  name: "TopMenu",
  data() {
    return {
      myRole: {},
    };
  },
  apollo: {
    myRole: Query.myRole,
  },
  computed: {
    hasRoles() {
      if (this.myRole) {
        /**
         * Có quyền Admin hoặc Owner để xem full báo cáo
         * hoặc quyền managers để xem các phần có quyền
         */
        if (
          this.myRole.isOwner ||
          this.myRole.isAdmin ||
          (this.myRole.approvalManagements &&
            this.myRole.approvalManagements.length > 0)
        ) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
